import React from 'react';
import { Markdown } from '../Markdown';
import Grid from '@mui/material/Grid';

export const MarkdownCell = ({ cell }) => {
  return (
    <React.Fragment>
      <Grid item xs={1}></Grid>
      <Grid item xs={11}>
        <Markdown source={cell.source.join('')} />
      </Grid>
    </React.Fragment>
  );
};
